import React from 'react';
import './Logo.css';

/**
 * Logo Wele — Système centralisé multi-variantes
 *
 * Props :
 *   variant  : "full"    → icône + wordmark CSS côte à côte (horizontal)
 *              "icon"    → icône PNG seule (sidebar réduite, favicon context)
 *              "stacked" → PNG portrait original (usage impression / grands espaces)
 *   theme    : "light"   → fond clair — couleurs natives + wordmark navy/bleu
 *              "dark"    → fond sombre — icône blanche + wordmark blanc
 *              "white"   → alias dark
 *   size     : "sm" | "md" | "lg" | "xl" — taille sémantique (optionnel)
 *   height   : hauteur px de l'icône (remplacé par size si fourni)
 *   className, style, alt
 */
const SIZES = { sm: 32, md: 44, lg: 56, xl: 72 };

const Logo = ({
  variant  = 'full',
  theme    = 'light',
  size,
  height   = 48,
  className = '',
  style    = {},
  alt      = 'Wele',
}) => {
  const iconH  = size ? SIZES[size] ?? height : height;
  const isDark = theme === 'dark' || theme === 'white';
  const themeClass = isDark ? 'gowele--dark' : 'gowele--light';

  /* ── Icône seule ── */
  if (variant === 'icon') {
    return (
      <img
        src="/logo-gowele.png"
        alt={alt}
        className={`gowele-icon ${themeClass} ${className}`}
        style={{ height: iconH, width: 'auto', objectFit: 'contain', display: 'block', ...style }}
        loading="eager"
        decoding="async"
      />
    );
  }

  /* ── PNG portrait original ── */
  if (variant === 'stacked') {
    return (
      <img
        src="/logo-gowele.png"
        alt={alt}
        className={`gowele-icon gowele-stacked ${themeClass} ${className}`}
        style={{ height: iconH, width: 'auto', objectFit: 'contain', display: 'block', ...style }}
        loading="eager"
        decoding="async"
      />
    );
  }

  /* ── Full = icône + wordmark côte à côte (horizontal) ── */
  return (
    <span
      className={`gowele-full ${themeClass} ${className}`}
      style={style}
      aria-label={alt}
      role="img"
    >
      <img
        src="/logo-gowele.png"
        alt=""
        aria-hidden="true"
        className="gowele-icon"
        style={{ height: iconH, width: 'auto', objectFit: 'contain', flexShrink: 0 }}
        loading="eager"
        decoding="async"
      />
      <span className="gowele-wordmark" aria-hidden="true">
        <span className="gowele-wele">Wele</span>
      </span>
    </span>
  );
};

export default Logo;
